export default __webpack_public_path__ + "static/media/Modelo-de-distrato-social-da-Sociedade-de-Advogados-denominada.ac3c8941.docx";